import React from 'react';
import PdfViewer from '../core/PdfViewer';

const Privacy = (props) => {
    return (
        <PdfViewer url="https://dynki.com/assets/privacy-policy.pdf"/>
    )
}

export default Privacy;